import React from 'react';
import styled, { css } from 'styled-components';
import { List } from './ContentStyles';
import { COLORS, ELEVATIONS, SIZES } from '../styleVars';
var ExpansionHeader = styled(List).withConfig({
  componentId: "sc-1wztyq7-0"
})(["box-sizing:border-box;cursor:pointer;user-select:none;width:100%;&:hover{background-color:", ";}"], COLORS.lightestGrey);
var ExpansionBody = styled.div.withConfig({
  componentId: "sc-1wztyq7-1"
})(["box-sizing:border-box;box-shadow:", ";background-color:", ";transition:", ";height:", "px;overflow:hidden;user-select:none;width:100%;"], ELEVATIONS.Accordion, function (props) {
  return props.bgColor ? props.bgColor : COLORS.lighterGrey;
}, function (props) {
  return props.init ? 'initial' : 'height 0.2s linear';
}, function (props) {
  return props.height;
});
var StyledSvg = styled.svg.withConfig({
  componentId: "sc-1wztyq7-2"
})(["fill:currentColor;width:1em;height:1em;display:inline-block;font-size:", ";color:", ";flex-shrink:0;transition:", ";transform:", ";", ""], SIZES[24], COLORS.darkerGrey, function (props) {
  return props.init ? 'transform 0s linear' : 'transform 0.2s linear';
}, function (props) {
  return props.open ? 'rotate(180deg)' : 'none';
}, function (props) {
  return props.addmargin && css(["margin-", ":", ";"], props.addmargin, SIZES['14']);
});

var ToggleIcon = function ToggleIcon(_ref) {
  var open = _ref.open,
      addmargin = _ref.addmargin,
      init = _ref.init,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(StyledSvg, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    addmargin: addmargin,
    style: style,
    open: open,
    init: init
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
};

export { ExpansionHeader, ExpansionBody, ToggleIcon };
//# sourceMappingURL=ExpansionStyles.js.map